import { slidesScratch } from './1848';
import { wijs } from './4209';
import { itAndMe } from './4567';
import { mockSlides } from './2334';

export const lessonsByStudioId = {
  1848: slidesScratch,
  2334: mockSlides,
  4209: wijs,
  4567: itAndMe,
};
